<template>
  <div class="mos" aria-live="polite">
    <p class="mos-total" :class="{ 'mos-total--empty': !hasItems }">{{ totalLabel }}</p>
    <p v-if="itemsLabel" class="mos-items" :title="itemsLabel">{{ itemsLabel }}</p>
  </div>
</template>

<script>
import { hasSelectedItems } from './materialsOrderSelection';
import { chosenItemsLabel, orderSummaryLabel } from './materialsOrderLayout';

export default {
  name: 'MaterialsOrderSummary',
  props: {
    items: { type: Array, default: () => [] },
    selection: { type: Object, default: () => ({}) },
  },
  computed: {
    hasItems() {
      return hasSelectedItems(this.selection);
    },
    totalLabel() {
      return orderSummaryLabel(this.selection);
    },
    itemsLabel() {
      return chosenItemsLabel(this.items, this.selection);
    },
  },
};
</script>

<style scoped>
.mos {
  flex: 1 1 240px;
  min-width: 0;
  align-self: center;
}
.mos-total {
  margin: 0;
  font-size: 13.5px;
  font-weight: 700;
  color: #1f2937;
}
.mos-total--empty {
  font-weight: 500;
  color: #4b5563;
}
.mos-items {
  margin: 2px 0 0;
  font-size: 12.5px;
  line-height: 1.4;
  color: #4b5563;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
